<section id="vm-sessie">
  <div class="gd__container">
    
    <div class='svgcontainter'>
      <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
      <svg version="1.1" id="Laag_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" viewBox="0 0 64 64" style="enable-background:new 0 0 64 64;" xml:space="preserve">
        <style type="text/css">
          .st0 {
            fill: none;
            stroke: #00CBC6;
            stroke-width: 2.6;
            stroke-linejoin: round;
            stroke-miterlimit: 10;
          }

          svg {
            width: 5rem;
          }

          #hamer {
            animation: rotatehamer 0.15s infinite linear 3s;
            transform-origin: 50% 50%;
          }

          #bel1 {
            animation: rotatebel 0.15s infinite linear 3s;
            transform-origin: 50% 50%;
          }

          #bel2 {
            animation: rotatebel 0.15s infinite linear 3.075s;
            transform-origin: 50% 50%;
          }


          @keyframes rotatehamer {
            50% {
              transform: rotate(-10deg);
            }

            100% {
              transform: rotate(10deg);
            }
          }

          @keyframes rotatebel {
            50% {
              transform: rotate(-1deg);
            }

            100% {
              transform: rotate(1deg);
            }
          }
        </style>
        <circle class="st0" cx="32" cy="35.4" r="20.6" />
        <path id="bel2" class="st0" d="M8.9,18.9c-2.7-4.4-1.4-10.2,3-12.9s10.2-1.4,12.9,3L8.9,18.9z" />
        <g id="hamer">
          <line class="st0" x1="32" y1="14.8" x2="32" y2="4.2" />
          <line class="st0" x1="28" y1="4.2" x2="36" y2="4.2" />
        </g>
        <path id="bel1" class="st0" d="M54.8,18.9c2.7-4.4,1.4-10.2-3-12.9c-4.4-2.7-10.2-1.4-12.9,3L54.8,18.9z" />
        <line class="st0" x1="21" y1="52.8" x2="15.9" y2="60.9" />
        <line class="st0" x1="43" y1="52.8" x2="48.1" y2="60.9" />
        <polyline class="st0" points="19.8,25.7 32,35.4 43.8,31.2 " />
      </svg>

    </div>

    <h2 [innerHTML]="pageTitle"></h2>
    <div class='tekst' [innerHTML]="pageContent"></div>
  </div>
</section>